import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { Fragment } from 'react';
import { OptionListBeforeSectionContainer, OptionListContainer, OptionListItemGroup, OptionListRoot, OptionListSearch, OptionListSearchContainer, OptionListVirtualPadding } from './style';
import { OPTION_LIST_CLASS_PREFIX } from './constants';
import { OptionListItem } from './OptionListItem';
import { useOptionList, useOptionListClassName } from './hooks';
import { useComponentTheme } from '../../utils/hooks';
import { OptionListFooter } from './OptionListFooter';
export var OptionList = function OptionList(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(OPTION_LIST_CLASS_PREFIX);

  var _useOptionList = useOptionList(props),
      rootProps = _useOptionList.rootProps,
      getOptionItemProps = _useOptionList.getOptionItemProps,
      getSelectAllItemProps = _useOptionList.getSelectAllItemProps,
      getOptionListSearchProps = _useOptionList.getOptionListSearchProps,
      listContainerProps = _useOptionList.listContainerProps,
      listProps = _useOptionList.listProps,
      enableVirtualization = _useOptionList.enableVirtualization,
      getVirtualTopSpaceProps = _useOptionList.getVirtualTopSpaceProps,
      getVirtualBottomSpaceProps = _useOptionList.getVirtualBottomSpaceProps,
      internalOptions = _useOptionList.internalOptions,
      dynamicInternalOptions = _useOptionList.dynamicInternalOptions,
      disabled = _useOptionList.disabled,
      internalValue = _useOptionList.internalValue,
      enableSearchOption = _useOptionList.enableSearchOption,
      isOptionListHeaderRendered = _useOptionList.isOptionListHeaderRendered,
      isFooterRendered = _useOptionList.isFooterRendered,
      optionListFooterProps = _useOptionList.optionListFooterProps,
      isSelectAllOptionRendered = _useOptionList.isSelectAllOptionRendered,
      groupIndex = _useOptionList.groupIndex;

  var classOverride = useOptionListClassName(OPTION_LIST_CLASS_PREFIX, className, disabled);
  var displayedGroups = {};
  return internalOptions.length ? React.createElement(OptionListRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), isOptionListHeaderRendered && React.createElement(OptionListBeforeSectionContainer, {
    theme: theme,
    className: classOverride.BeforeSectionContainer
  }, enableSearchOption && React.createElement(OptionListSearchContainer, {
    theme: theme,
    className: classOverride.SearchContainer
  }, React.createElement(OptionListSearch, Object.assign({}, getOptionListSearchProps(), {
    theme: theme,
    className: classOverride.Search
  })))), React.createElement(OptionListContainer, Object.assign({
    theme: theme,
    className: classOverride.OptionListContainer
  }, listContainerProps), isSelectAllOptionRendered && React.createElement(OptionListItem, Object.assign({}, getSelectAllItemProps(), {
    className: classOverride.SelectAllItem
  })), React.createElement("div", Object.assign({}, listProps), enableVirtualization && React.createElement(OptionListVirtualPadding, Object.assign({}, getVirtualTopSpaceProps(), {
    className: classOverride.VirtualPaddingTop,
    theme: theme
  })), dynamicInternalOptions.map(function (option, index) {
    var value = option.value,
        groupId = option.groupId;
    var group = null;

    if (groupId && groupId in groupIndex && !displayedGroups[groupId]) {
      group = groupIndex[groupId];
      displayedGroups[groupId] = true;
    }

    return React.createElement(Fragment, {
      key: value
    }, !!group && React.createElement(OptionListItemGroup, {
      enableSeparator: index > 0,
      theme: theme,
      className: classOverride.ItemGroup
    }, group.label), React.createElement(OptionListItem, Object.assign({}, getOptionItemProps(option), {
      className: "".concat(classOverride.Item, " ").concat(internalValue.includes(value) ? 'active' : '')
    })));
  }), enableVirtualization && React.createElement(OptionListVirtualPadding, Object.assign({}, getVirtualBottomSpaceProps(), {
    className: classOverride.VirtualPaddingBottom,
    theme: theme
  })))), isFooterRendered && React.createElement(OptionListFooter, Object.assign({}, optionListFooterProps, {
    className: classOverride.Footer
  }))) : null;
};